import { axios } from '@/plugins/axios'
import { IResponseTranslation } from '@/api/types'

export const loadTranslations = async (language: string) => {
  const response = await axios.get<IResponseTranslation>(`/translations/${language}/`)
  return response.data.translation
}
